module.exports = __webpack_public_path__ + "img/about.0ed347c.png";